<template>
	<div class="order-item">
		<div class="header">
			<span>订单编号：{{order_no||""}}</span>
			<span>{{created_at||''}}</span>
		</div>
		<div class="card">
			<el-image class="img flex-shrink" :src="product_img" v-if="product_img" :fit="'cover'"></el-image>
			<div class="base">
				<div class="title">{{product_class||''}}</div>
				<div class="num">数量：{{product_number||0}}</div>
				<Tag color="success" v-if="order_type == 2">一口价</Tag>
				<Tag color="warning" v-if="order_type == 1">报价招标</Tag>
			</div>
			<div class="service">
				<div>订单联系人</div>
				<div class="content">{{contact||""}}</div>
			</div>
			<div class="contact">
				<div>客户联系方式</div>
				<div class="phone">{{phone||""}}</div>
				<div class="address text-cut-4">{{address||""}}</div>
			</div>
			<div class="service">
				<div>服务类型</div>
				<div class="content">{{service_name||""}}</div>
			</div>
			<div class="service">
				<div>状态</div>
				<div class="content" v-if='order_type==1'>{{status_name||""}}</div>
				<div class="content" v-else>{{status==2?'待抢单':status_name||""}}</div>
			</div>
			<div class="service">
				<div>{{order_type == 1 ? '师傅报价' : (order_type == 2 ? '一口价' : '订单金额')}}</div>
				<div class="content">{{priceText}}</div>
				<!--        <div class="time">剩余时间：20小时30分</div>-->
			</div>
			<div class="remark">
				<div>订单备注</div>
				<span class="remark-total" v-if="remarkCount">({{remarkCount}})</span>
				<div class="remark-list" v-if="latestRemark">
					<div class="remark-item" :title="latestRemark.content" @click="openRemark()">
						<span class="flag-icon" :style="{'--flag-color': latestRemark.color}"></span>
						<span class="remark-content">{{latestRemark.content}}</span>
						<span class="remark-text">备注</span>
					</div>
				</div>
				<div class="remark-empty" v-else @click="openRemark()">
					<span class="flag-icon" :style="{'--flag-color': remarkForm.color}"></span>
					<span>备注</span>
				</div>
			</div>
			<!-- 1待报价,2待雇佣,3待支付,4待上门,5服务中,6待验收,7待评价,8已完成,9交易关闭,10第二次上门,11第一次售后,12第二次售后 -->
			<div class="handle" :class="{'handle-one-column': actionCount <= 2, 'handle-two-column': actionCount > 2}">
				<el-button type="success" size="small" v-if="status ==3"
					@click="$router.push({name:'order_pay',params:{id:id}})">立即付款</el-button>
          <el-button type="primary" size="mini" class="margin-top" v-if="status < 4"
          	@click="changeOrder()">修改订单
          </el-button>
				<el-button type="primary" size="mini" class="margin-top" v-if="status <= 4&&status!=3"
					@click="cancel()">取消订单
				</el-button>
				<el-button type="primary" size="mini" class="margin-top" v-if="status ==4||status ==5" style="margin: 20rpx 0;" @click="$router.push({ name: 'order_pay', params: { id: id, type: 'addMoney' } })">增加费用
				</el-button>
				<el-button type="primary" size="mini" class="margin-top" v-if="status ==4" @click="tipsBtn()">催师傅上门
				</el-button>
				<el-button type="warning" size="mini" class="margin-top" v-if="status ==5" @click="confirmReciv()">完工码
				</el-button>
				<el-button type="warning" size="mini" class="margin-top" v-if="status ==5" @click="$router.push({ name: 'order_complaint', params: { id: id } })">申请售后
				</el-button>
				<el-button type="info" size="small" v-if="status ==6"
					@click="$router.push({name:'order_refund',params:{id:id}})">申请退款</el-button>
				<el-button type="warning" size="small" v-if="status ==6" @click="confirmReciv()">完工码</el-button>
				<el-button type="primary" size="small" v-if="status ==6" :loading="acceptanceLoading"
					:disabled="acceptanceLoading" @click="checkAcceptanceStatus()">确认验收</el-button>
				<!-- <el-button type="primary" size="small"  v-if="status ==6" @click="goCompleteCode()">出示完工码</el-button> -->
				<el-button type="success" size="small" v-if="status ==7"
					@click="$router.push({name:'order_evaluate',params:{id:id}})">去评价</el-button>
				<el-button type="success" size="small" v-if="status ==2&&order_type==1"
					@click="$router.push({name:'order_detail',params:{id:id,activwName:'second'}})">雇佣师傅</el-button>
				<!--  -->
				<el-button type="danger" size="small" @click="delOrder()" v-if="status ==8||status ==9||status > 14">
					删除订单
				</el-button>
				<el-button size="small" @click="$router.push({name:'order_detail',params:{id:id}})">查看详情</el-button>
				<!-- <div class="info-btn line-eee wn50 padding-tb-4 radius-6" @click="$router.push({name:'order_detail',params:{id:id}})">查看详情</div> -->
			</div>
		</div>
		<el-dialog title="订单标记 / 备注" :visible.sync="remarkModal" width="680px" custom-class="remark-dialog">
			<div class="remark-form">
				<div class="remark-history" v-if="remarkList.length">
					<div
						class="remark-history-item"
						:class="{active: isEditingRemark(item)}"
						v-for="(item, index) in remarkList"
						:key="index"
						@click="editRemarkItem(item)">
						<span class="flag-icon" :style="{'--flag-color': item.color}"></span>
						<span class="remark-history-content">{{item.content}}</span>
					</div>
				</div>
				<div class="remark-form-row">
					<span class="remark-form-label">旗帜颜色：</span>
					<div class="flag-select-list">
						<span
							class="flag-select"
							:class="{active: remarkForm.color === item}"
							v-for="item in flagColors"
							:key="item"
							@click="remarkForm.color = item">
							<span class="flag-icon" :style="{'--flag-color': item}"></span>
						</span>
					</div>
				</div>
				<div class="remark-form-row remark-textarea-row">
					<span class="remark-form-label">备注内容：</span>
					<div class="remark-textarea-box">
						<el-input
							type="textarea"
							:rows="5"
							maxlength="200"
							placeholder="标记内容仅自己可见，200字以内"
							v-model="remarkForm.remark">
						</el-input>
						<div class="remark-count">{{remarkForm.remark.length}}/200</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="danger" plain :loading="remarkDeleting" v-if="false && editingRemarkId" @click="deleteRemark">删除备注</el-button>
				<el-button @click="clearRemark">清空</el-button>
				<el-button @click="remarkModal = false">取消</el-button>
				<el-button type="primary" :loading="remarkLoading" @click="saveRemark">确定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="修改手机号" :visible.sync="phoneModal" width="420px" custom-class="phone-edit-dialog">
			<el-form label-width="90px">
				<el-form-item label="手机号码">
					<el-input
						v-model="phoneForm.phone"
						maxlength="11"
						placeholder="请输入手机号"
						@input="phoneForm.phone = phoneForm.phone.replace(/\D/g, '').slice(0, 11)">
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="phoneModal = false">取消</el-button>
				<el-button type="primary" :loading="phoneSaving" @click="savePhone">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
const ORDER_REMARK_API = '690000000001'
const ORDER_REMARK_LIST_API = '690000000002'
const ORDER_REMARK_DELETE_API = '690000000003'

export default {
  name: 'order-item',
  props: {
    order_no: {
      type: String,
      default: ''
    },
    product_img: {
      type: String,
      default: ''
    },
    contact: {
      type: String,
      default: ''
    },
    status_name: {
      type: String,
      default: ''
    },
    created_at: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    service_name: {
      type: String,
      default: ''
    },
    product_class: {
      type: String,
      default: ''
    },
    product_number: {
      type: Number,
      default: ''
    },
    order_type: {
      type: Number,
      default: 1
    },
    price: {
      type: String,
      default: ''
    },
    show_offer: {
      type: [String, Number],
      default: ''
    },
    status: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    remark: {
      type: String,
      default: ''
    },
    remark_list: {
      type: [Array, String, Object],
      default: () => []
    },
    remark_count: {
      type: [Number, String],
      default: 0
    },
    flag_color: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      remarkModal: false,
      remarkLoading: false,
      remarkDeleting: false,
      remarkListLoading: false,
      flagColors: ['#ff4d4f', '#ff7a00', '#faad14', '#52c41a', '#315ce7', '#13b5b1', '#722ed1', '#eb2f96'],
      remarkForm: {
        remark: '',
        color: this.flag_color || '#ff4d4f',
        id: '',
        remark_id: ''
      },
      remarkList: this.formatRemarkList(),
      remarkTotal: Number(this.remark_count) || 0,
      acceptanceLoading: false,
      phoneModal: false,
      phoneLoading: false,
      phoneSaving: false,
      phoneForm: {
        name: '',
        phone: '',
        pro_city_dist: '',
        detailed_address: '',
        address: '',
        floor: '',
        is_elevator: '',
        number: 0,
        price: 0,
        latitude: '',
        longitude: '',
        is_virtual: 0
      }
    }
  },
  computed: {
    actionCount () {
      let count = 1
      if (this.status == 3) count += 1
      if (this.status < 4) count += 1
      if (this.status <= 4 && this.status != 3) count += 1
      if (this.status == 4 || this.status == 5) count += 1
      if (this.status == 4) count += 1
      if (this.status == 5) count += 2
      if (this.status == 6) count += 3
      if (this.status == 7) count += 1
      if (this.status == 2 && this.order_type == 1) count += 1
      if (this.status == 8 || this.status == 9 || this.status > 14) count += 1
      return count
    },
    remarkCount () {
      return this.remarkTotal || this.remarkList.length
    },
    latestRemark () {
      const getRank = item => {
        const time = item.created_at || item.create_time || item.created_time || item.add_time || item.updated_at || item.update_time || ''
        return Date.parse(time) || Number(item.id || item.remark_id || 0) || 0
      }
      return this.remarkList.slice().sort((a, b) => getRank(b) - getRank(a))[0] || null
    },
    editingRemarkId () {
      return this.remarkForm.id || this.remarkForm.remark_id || ''
    },
    priceText () {
      if (this.order_type == 1) {
        const hasOffer = this.show_offer !== undefined && this.show_offer !== null && this.show_offer !== '' && Number(this.show_offer) > 0
        return hasOffer ? `￥${this.show_offer}` : '暂无师傅报价'
      }
      return `￥${this.price || 0}`
    }
  },
  watch: {
    remark () {
      this.remarkList = this.formatRemarkList()
    },
    remark_list () {
      this.remarkList = this.formatRemarkList()
    },
    remark_count (value) {
      this.remarkTotal = Number(value) || this.remarkList.length
    },
    flag_color (value) {
      this.remarkForm.color = value || this.remarkForm.color
    }
  },
  methods: {
    getRemarkList () {
      let vm = this
      this.remarkListLoading = true
      return this.$request(ORDER_REMARK_LIST_API, {
        order_id: vm.id,
        page: 1
      }).then(res => {
        const data = res.data.data || []
        const list = Array.isArray(data) ? data : (data.list || data.data || data.rows || [])
        const total = Array.isArray(data) ? list.length : (data.total || data.count || data.listCount || data.list_count || list.length)
        vm.remarkList = list.map(item => {
          return {
            content: item.remark || item.remarks || item.content || item.note || item.text || '',
            color: item.color || item.flag_color || item.remark_color || '#ff4d4f',
            id: item.id,
            remark_id: item.remark_id,
            created_at: item.created_at,
            create_time: item.create_time,
            created_time: item.created_time,
            add_time: item.add_time,
            updated_at: item.updated_at,
            update_time: item.update_time
          }
        }).filter(item => item.content)
        vm.remarkTotal = Number(total) || vm.remarkList.length
        return vm.remarkList
      }).finally(() => {
        vm.remarkListLoading = false
      })
    },
    formatRemarkList () {
      const defaultColor = this.flag_color || '#ff4d4f'
      const source = this.remark_list
      const normalize = item => {
        if (!item) return null
        if (typeof item === 'string') {
          return {
            content: item,
            color: defaultColor
          }
        }
        const content = item.remark || item.remarks || item.content || item.note || item.text || ''
        return content ? {
          content,
          color: item.flag_color || item.remark_color || item.color || defaultColor,
          id: item.id,
          remark_id: item.remark_id,
          created_at: item.created_at,
          create_time: item.create_time,
          created_time: item.created_time,
          add_time: item.add_time,
          updated_at: item.updated_at,
          update_time: item.update_time
        } : null
      }
      if (Array.isArray(source) && source.length) {
        return source.map(normalize).filter(Boolean)
      }
      const singleRemark = normalize(source) || normalize(this.remark)
      return singleRemark ? [singleRemark] : []
    },
    openRemark () {
      this.editRemarkItem(this.latestRemark)
      this.remarkModal = true
    },
    editRemarkItem (item) {
      const remark = item || {}
      this.remarkForm.remark = remark.content || ''
      this.remarkForm.color = remark.color || this.flag_color || this.remarkForm.color
      this.remarkForm.id = remark.id || ''
      this.remarkForm.remark_id = remark.remark_id || ''
    },
    isEditingRemark (item) {
      const editingId = this.remarkForm.id || this.remarkForm.remark_id
      const itemId = item && (item.id || item.remark_id)
      return editingId && itemId && editingId == itemId
    },
    clearRemark () {
      this.remarkForm.remark = ''
    },
    deleteRemark () {
      const remarkId = this.editingRemarkId
      if (!remarkId) return
      this.$confirm('确定删除当前备注吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          order_id: this.id
        }
        if (this.remarkForm.id) params.id = this.remarkForm.id
        if (this.remarkForm.remark_id) params.remark_id = this.remarkForm.remark_id
        this.remarkDeleting = true
        this.$request(ORDER_REMARK_DELETE_API, params).then(() => {
          this.remarkModal = false
          this.$emit('refresh')
          this.$message.success('备注删除成功')
        }).finally(() => {
          this.remarkDeleting = false
        })
      })
    },
    saveRemark () {
      let vm = this
      if (!this.remarkForm.remark) {
        this.$message.error('请输入备注内容')
        return
      }
      this.remarkLoading = true
      const params = {
        order_id: vm.id,
        remark: vm.remarkForm.remark,
        color: vm.remarkForm.color,
        is_common: 1
      }
      if (vm.remarkForm.id) params.id = vm.remarkForm.id
      if (vm.remarkForm.remark_id) params.remark_id = vm.remarkForm.remark_id
      this.$request(ORDER_REMARK_API, params).then(() => {
        vm.remarkModal = false
        vm.$emit('refresh')
        vm.$message.success('备注保存成功')
      }).finally(() => {
        vm.remarkLoading = false
      })
    },
    confirmReciv () {
      let vm = this
      this.$util.throttle(() => {
        this.$request('614a8b63980c2', {
          order_id: vm.id
        }).then(res => {
          this.$Confirm({
            title: '验收提醒',
            showCancel: false,
            desc: '如果师傅已经完成服务，请将下方核销码告知师傅，确认验收',
            text: res.data.data.finished_code
          }).then(res => {
            console.log(res)
          })
        })
      }, 2000, true)
    },
    getPhoneFormFromDetail (data) {
      const address = data.address || {}
      const product = data.product || {}
      return {
        name: address.name || this.contact || '',
        phone: address.phone || this.phone || '',
        pro_city_dist: address.pro_city_dist || address.city || '',
        detailed_address: address.detailed_address || address.address || '',
        address: address.address || [address.pro_city_dist || address.city || '', address.detailed_address || ''].filter(Boolean).join('-'),
        floor: address.floor === undefined || address.floor === null ? '' : String(address.floor),
        is_elevator: address.is_elevator === undefined || address.is_elevator === null ? (address.floor ? '0' : '1') : String(address.is_elevator),
        number: address.number || product.num || 0,
        price: address.price || product.reference || product.product_price || 0,
        latitude: address.latitude || '',
        longitude: address.longitude || '',
        is_virtual: Number(address.is_virtual || address.is_virtual_phone || address.virtual_phone || 0)
      }
    },
    savePhone () {
      let vm = this
      if (!this.phoneForm.phone) {
        return this.$message.error('请输入手机号')
      }
      if (!/^1[3-9]\d{9}$/.test(this.phoneForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      this.phoneSaving = true
      this.$request('611cbabeb8a86', {
        name: vm.phoneForm.name,
        phone: vm.phoneForm.phone,
        pro_city_dist: vm.phoneForm.pro_city_dist,
        detailed_address: vm.phoneForm.detailed_address,
        address: vm.phoneForm.address || [vm.phoneForm.pro_city_dist, vm.phoneForm.detailed_address].filter(Boolean).join('-'),
        floor: String(vm.phoneForm.floor || ''),
        is_elevator: vm.phoneForm.is_elevator,
        number: vm.phoneForm.number,
        price: vm.phoneForm.price,
        latitude: vm.phoneForm.latitude,
        longitude: vm.phoneForm.longitude,
        is_virtual: vm.phoneForm.is_virtual,
        order_no: vm.id || ''
      }).then(() => {
        vm.phoneModal = false
        vm.$message.success('修改成功')
        vm.$emit('refresh')
      }).finally(() => {
        vm.phoneSaving = false
      })
    },
    checkAcceptanceStatus () {
      if (this.acceptanceLoading) return
      let vm = this
      this.acceptanceLoading = true
      this.$request('6120ad9af2b9b', {
        order_id: vm.id
      }).then(res => {
        const status = Number(res.data.data.status)
        if (status === 7) {
          vm.$router.push({
            name: 'order_evaluate',
            params: {
              id: vm.id
            }
          })
          return
        }
        vm.$message({
          type: 'warning',
          message: '请等待师傅操作完成',
          customClass: 'acceptance-wait-message',
          center: true,
          duration: 3000
        })
        vm.$emit('refresh')
      }).finally(() => {
        vm.acceptanceLoading = false
      })
    },
    // 修改订单
    changeOrder () {
      this.$router.push({
        name: 'place',
        query: {
          order_id: this.id
        }
      })
    },
    cancel () {
      let vm = this
      this.$cancelOrder({
        id: vm.id
      }).then(res => {
        if (res == 'confirm') {
          console.log('----')
          this.$message.success('操作成功')
          location.reload()
        }
      })
    },
    // 催师傅上门
    tipsBtn () {
      let vm = this
      this.$request('62d52495589e7', {
        order_id: vm.id
      }).then(res => {
        this.$message({
          type: 'success',
          message: '提醒成功!'
        })
      })
    },
    // 删除订单
    delOrder () {
      let vm = this
      this.$confirm('此操作将删除此订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$request('614c4dbce8c6d', {
          order_id: vm.id
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          location.reload()
        })
      }).catch((err) => {
        console.log(err, 'err')
        this.$message({
          type: 'info',
          message: '删除失败'
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
	.order-item {
		margin-top: 15px;

		.header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: #f7f8fa;
			height: 40px;
			padding: 0 10px;
			font-size: 14px;
		}

		.card {
			width: 100%;
			min-height: 100px;
			margin: 10px auto;
			display: flex;
			align-items: center;

			.img {
				width: 80px;
				height: 80px;
			}

			.base {
				width: 17%;
				margin-left: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.ivu-tag {
					display: inline-block;
					flex: none;
					width: 75px;
					text-align: center;
				}

				.num {
					color: #999;
				}
			}

			.contact {
				width: 17%;

				.phone {
					font-weight: 600;
					margin-top: 5px;
				}

				.address {
					color: #999999;
					margin-top: 5px;
					font-size: 12px;
				}
			}

			.service {
				width: 12%;
				margin-left: 30px;

				.content {
					font-size: 18px;
					font-weight: 600;
					margin-top: 5px;
				}
			}

			.remark {
				width: 10%;
				min-width: 120px;
				margin-left: 30px;
				color: #111111;

				> div:first-child {
					display: inline-block;
				}

				.remark-total {
					margin-left: 4px;
					color: #999999;
					font-size: 12px;
				}

				.remark-list {
					margin-top: 8px;
				}

				.remark-item {
					display: flex;
					align-items: center;
					width: 100%;
					min-width: 0;
					margin-bottom: 6px;
					cursor: pointer;
				}

				.remark-text {
					display: none;
					color: #999999;
					font-size: 12px;
					line-height: 20px;
				}

				.remark-content {
					flex: 1;
					min-width: 0;
					max-width: 100%;
					overflow: hidden;
					color: #999999;
					font-size: 12px;
					line-height: 20px;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.remark-empty {
					color: #999999;
					font-size: 12px;
					line-height: 20px;
					margin-top: 8px;
					cursor: pointer;
					display: flex;
					align-items: center;
				}
			}

			.handle {
				flex: 1;
				display: grid;
				gap: 8px 8px;
				justify-content: end;
				align-content: center;

				.btn {
					margin-top: 15px;
					margin-bottom: 5px;
					padding: 0px 20px;
				}

				/deep/.el-button {
					width: 80px;
					margin: 0 !important;
					padding-left: 0;
					padding-right: 0;
				}

				.info-btn {
					cursor: pointer;
				}
			}

			.handle-one-column {
				grid-template-columns: 80px;
			}

			.handle-two-column {
				grid-template-columns: repeat(2, 80px);
			}
		}
	}

	/deep/.el-button {
		margin: 6px 0;
	}

	.flag-icon {
		position: relative;
		display: inline-block;
		width: 15px;
		height: 16px;
		margin: 0 6px 0 0;
		flex-shrink: 0;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			width: 3px;
			height: 16px;
			background-color: var(--flag-color);
		}

		&::after {
			content: '';
			position: absolute;
			left: 3px;
			top: 0;
			width: 10px;
			height: 8px;
			background-color: var(--flag-color);
			clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 65%, 0 100%);
		}
	}

	.remark-form {
		.remark-history {
			max-height: 180px;
			overflow-y: auto;
			margin-bottom: 22px;
			padding: 10px 12px;
			background-color: #fafafa;
			border: 1px solid #eeeeee;
			border-radius: 4px;
		}

		.remark-history-item {
			display: flex;
			align-items: flex-start;
			color: #666666;
			font-size: 13px;
			line-height: 20px;
			padding: 6px;
			border-radius: 4px;
			cursor: pointer;

			&.active {
				background-color: #fff7e6;
			}

			& + .remark-history-item {
				margin-top: 4px;
			}

			.flag-icon {
				margin-top: 2px;
			}
		}

		.remark-history-content {
			flex: 1;
			word-break: break-all;
		}

		.remark-form-row {
			display: flex;
			align-items: center;
			margin-bottom: 24px;
		}

		.remark-textarea-row {
			align-items: flex-start;
			margin-bottom: 0;
		}

		.remark-form-label {
			width: 90px;
			color: #333333;
			flex-shrink: 0;
		}

		.flag-select-list {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
		}

		.flag-select {
			width: 42px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			border: 1px solid transparent;
			border-radius: 7px;
			margin-right: 6px;
			box-sizing: border-box;

			.flag-icon {
				margin-right: 0;
			}

			&.active {
				border-color: #2a89ff;
				box-shadow: 0 0 0 2px rgba(42, 137, 255, 0.08);
			}
		}

		.remark-textarea-box {
			flex: 1;
			position: relative;
		}

		.remark-count {
			color: #999999;
			font-size: 12px;
			text-align: right;
			margin-top: 8px;
		}
	}

	/deep/.remark-dialog {
		border-radius: 5px;
		margin: 0 !important;

		.el-dialog__body {
			padding: 26px 16px 14px;
		}

		.el-dialog__footer {
			padding: 8px 16px 16px;
			text-align: right;
		}

		.el-textarea__inner {
			min-height: 116px !important;
			border-color: #ff9d2e;
		}

		.el-button--primary {
			background-color: #ff9d2e;
			border-color: #ff9d2e;
		}

		.dialog-footer {
			.el-button {
				margin: 0 0 0 10px;
			}

			.el-button:first-child {
				margin-left: 0;
			}
		}
	}

	/deep/.el-dialog__wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>

<style lang="less">
	.acceptance-wait-message {
		position: fixed !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%) !important;
		z-index: 3000 !important;
		min-width: 360px;
		padding: 20px 34px;
		border: 1px solid #f08a24;
		border-radius: 6px;
		background-color: #f08a24;
		box-shadow: 0 10px 28px rgba(240, 138, 36, 0.28);

		.el-message__content {
			color: #ffffff;
			font-size: 18px;
			font-weight: 600;
			line-height: 24px;
		}

		.el-message__icon {
			color: #ffffff;
			font-size: 20px;
		}
	}
</style>
